module.exports = __webpack_public_path__ + "img/map.ef887e52.jpg";